import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=df5794f4&scoped=true&"
import script from "./Automation.vue?vue&type=script&lang=js&"
export * from "./Automation.vue?vue&type=script&lang=js&"
import style0 from "./Automation.vue?vue&type=style&index=0&id=df5794f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5794f4",
  null
  
)

export default component.exports